import { getAll as getAllFacesPatri } from '@/api/gabed/face/index';
import { getAll as getAllEmplacementPatri } from '@/api/gabed/emplacement/index';
import { getAll as getAllDispositifPatri } from '@/api/gabed/dispositif/index';
import { getAll as getAllMaterielPatri } from '@/api/gabed/materiel/index';
import { getAll as getAllReseauxTempo } from '@/api/produit/produitReseau';
import { getAll as getAllReseauxLc } from '@/api/produit/produitReseauLc';
import getAllTourneeLigne from '@/api/logistique/tourneeLigne/index';
import * as tourneeConf from '@/configuration/logistique/tournee/tourneeConf';
import getAgenceId from '@/services/general/getSocieteId';
import { DEMONTE } from '@/configuration/gabed/dispositif/dispositifPublicitaire';

async function getFaces(query, tourneeLignes, idTournee) {
  const facesIdDejaPresente = tourneeLignes.map((tourneeligne) => { return tourneeligne.faceId; });
  const facesPatri = (await getAllFacesPatri({ query: query })).data.result.items;
  const faceIds = facesPatri.map((face) => { return face.id; });
  const tourneeLigneWithFaceId = (
    await getAllTourneeLigne({ query: { faceIds: faceIds, societeId: query.societeId } })
  ).data.result.items;
  const facesReturn = [];
  if (facesPatri.length <= 0) {
    return facesReturn;
  }
  facesPatri.forEach((face) => {
    face.libelle = face.code + ' - ' + face.materiel.dispositif.adresse.adresse1 + ', ' + face.materiel.dispositif.adresse.codePostal + ' ' + face.materiel.dispositif.adresse.ville;
    face.typeProduit = tourneeConf.TYPE_FACE;
    face.disabled = !!(facesIdDejaPresente.some((id) => {
      return id === face.id;
    })) || (tourneeLigneWithFaceId.some((ligne) => {
      return ligne.faceId === face.id && ligne.tournee.id !== idTournee;
    }));
    face.adresse = face.materiel.dispositif.adresse;
    facesReturn.push(face);
  });
  facesReturn.unshift({ title: 'addEditTourneeModele.associesFaceReseau.faceUnitaire' });

  return facesReturn;
}

async function getEmplacements(query) {
  const emplacementsPatri = (await getAllEmplacementPatri({ query: query, sorting: 'code' })).data.result.items;
  const emplacementReturn = [];
  if (emplacementsPatri.length <= 0) {
    return emplacementReturn;
  }
  emplacementsPatri.forEach((emplacement) => {
    emplacementReturn.push({
      typeProduit: tourneeConf.TYPE_EMPLACEMENT,
      disabled: false,
      libelle: emplacement.code + ' - ' + emplacement.adresseCadastrale.adresse1 + ', ' + emplacement.adresseCadastrale.codePostal + ' ' + emplacement.adresseCadastrale.ville,
      id: emplacement.id,
      facesId: null,
      adresse: emplacement.adresseCadastrale,
    });
  });
  emplacementReturn.unshift({ title: 'addEditTourneeModele.associesFaceReseau.emplacements' });

  return emplacementReturn;
}

async function getDispositifs(query) {
  const dispositifsPatri = (await getAllDispositifPatri({ query: query, sorting: 'code' })).data.result.items;
  const dispositifReturn = [];
  if (dispositifsPatri.length <= 0) {
    return dispositifReturn;
  }
  dispositifsPatri.forEach((dispo) => {
    dispositifReturn.push({
      typeProduit: tourneeConf.TYPE_DISPOSITIF,
      disabled: false,
      libelle: dispo.code + ' - ' + dispo.adresse.adresse1 + ', ' + dispo.adresse.codePostal + ' ' + dispo.adresse.ville,
      id: dispo.id,
      adresse: dispo.adresse,
    });
  });
  dispositifReturn.unshift({ title: 'addEditTourneeModele.associesFaceReseau.dispositifs' });

  return dispositifReturn;
}

async function getMateriels(query) {
  const materielsPatri = (await getAllMaterielPatri({ query: query, sorting: 'code' })).data.result.items;
  const materielsReturn = [];
  if (materielsPatri.length <= 0) {
    return materielsReturn;
  }
  materielsPatri.forEach((materiel) => {
    materielsReturn.push({
      typeProduit: tourneeConf.TYPE_MATERIEL,
      disabled: materiel.etat === DEMONTE,
      libelle: materiel.code + ' - ' + materiel.dispositif.adresse.adresse1 + ', ' + materiel.dispositif.adresse.codePostal + ' ' + materiel.dispositif.adresse.ville,
      id: materiel.id,
      adresse: materiel.dispositif.adresse,
    });
  });
  materielsReturn.unshift({ title: 'addEditTourneeModele.associesFaceReseau.materiels' });
  return materielsReturn;
}
async function getReseauTempo(query) {
  const agenceId = await getAgenceId();
  const reseauTempo = (await getAllReseauxTempo({ query: query, agenceId })).data.result.items;
  const reseauTempoReturn = [];
  if (reseauTempo.length <= 0) {
    return reseauTempoReturn;
  }
  reseauTempo.forEach((reseau) => {
    reseauTempoReturn.push({
      id: reseau.id,
      libelle: reseau.libelle + ' - ' + (reseau.produitReseau.adresse.codePostal ? reseau.produitReseau.adresse.codePostal : '') + ' ' + reseau.produitReseau.adresse.ville,
      typeProduit: tourneeConf.TYPE_REGROUPEMENT_TEMPO,
      disabled: false,
    });
  });
  reseauTempoReturn.unshift({ title: 'addEditTourneeModele.associesFaceReseau.reseauTempo' });
  return reseauTempoReturn;
}

async function getReseauLc(query) {
  const reseauLc = (await getAllReseauxLc({ query: query })).data.result.items;
  const reseauLcReturn = [];
  if (reseauLc.length <= 0) {
    return reseauLcReturn;
  }
  reseauLc.forEach((reseau) => {
    reseauLcReturn.push({
      id: reseau.id,
      libelle: reseau.libelle + ' - ' + (reseau.produitReseau.adresse.codePostal ? reseau.produitReseau.adresse.codePostal : '') + ' ' + reseau.produitReseau.adresse.ville,
      typeProduit: tourneeConf.TYPE_REGROUPEMENT_LC,
      disabled: false,
    });
  });
  reseauLcReturn.unshift({ title: 'addEditTourneeModele.associesFaceReseau.reseauLc' });

  return reseauLcReturn;
}

export default async function getAllElementForAddTournne(query, tourneeLignes, idTournee) {
  let facesAndReseaux = [];
  facesAndReseaux = await getEmplacements(query);
  facesAndReseaux = facesAndReseaux.concat(await getDispositifs(query));
  facesAndReseaux = facesAndReseaux.concat(await getMateriels(query));
  facesAndReseaux = facesAndReseaux.concat(await getFaces(query, tourneeLignes, idTournee));
  facesAndReseaux = facesAndReseaux.concat(await getReseauTempo(query));
  facesAndReseaux = facesAndReseaux.concat(await getReseauLc(query));
  return facesAndReseaux;
}

export async function getAllElementPatri(query) {
  let elements = [];
  elements = await getEmplacements(query);
  elements = elements.concat(await getDispositifs(query));
  elements = elements.concat(await getMateriels(query));
  elements = elements.concat(await getFaces(query, [], null));
  return elements;
}

export function getAllElementPatriDivers(query) {
  return getDispositifs(query);
}
